import { AfterContentChecked, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NzNotificationService } from "ng-zorro-antd";
import { floatToStringFormat, stringFormatToFloat } from 'src/app/fieldTypes/TextFields';
import { FormsService } from 'src/app/services/forms.service';
import { FieldTypeCode, TITLE } from 'src/app/utils/enum';
import { FormFieldInfo } from '../../../../models/forms-response.models';

@Component({
    selector: 'app-component-radiobutton',
    templateUrl: './radiobutton.component.html',
    styleUrls: ['./radiobutton.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RadiobuttonComponent implements OnInit, OnChanges, AfterViewInit, AfterContentChecked {
    @Input() formFieldInfo: FormFieldInfo;
    @Input() listFormFieldInfo: FormFieldInfo[];
    @Input() itemList: FormFieldInfo[];
    @Input() numberFormFieldInfo: FormFieldInfo;
    @Input() formGroup: FormGroup;
    @Input() formData: any;
    @Input() modalTitle:any;
    textValue:any
    formFieldConfig: any;
    fieldConfig: any;
    name: string;
    hideTitle: boolean;
    tooltip: string;

    isHiglineField: any;
    itemSubSection: any;

    dependentField = [];
    unDependentOption = [];
    customfieldOptionList = [];
    dependentFieldsOption = [];
    itemListByValue: FormFieldInfo[] = [];
    radioValue: string;
    fieldCode: string;
    isNumeric: boolean;
    radioInput: string;
    calValue: any;
    fieldDataInfo:any;
    isHiddenSubItem = true;
    allowInput = false;
    isDisplayDivOptionOfRadioButton = false;
    inputSubValue:string='';
    inputFieldCode:any;
    inputOptionCode:any
    selectChildData: any;
    taxCode="";
    formCode="";
    flag = false;

    constructor(
        private nzModalNotification: NzNotificationService,
        private elementRef: ElementRef,
        private cdref: ChangeDetectorRef,
        private formService: FormsService) {
    }

    ngOnChanges(): void {
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    ngOnInit(): void {
        try {
            this.formFieldConfig = this.formFieldInfo.formFieldConfig ? JSON.parse(this.formFieldInfo.formFieldConfig) : "";
            this.fieldConfig = this.formFieldInfo.fieldConfig ? JSON.parse(this.formFieldInfo.fieldConfig) : "";
            this.fieldCode = this.formFieldInfo.fieldCode;
            if(this.fieldCode=='RADIO_BUTTON_SubSystemUsaged'){
            }
            this.fieldDataInfo=this.formFieldInfo;
            if (this.fieldConfig) {
                this.dependentField = this.fieldConfig.dependentField;
                this.unDependentOption = this.fieldConfig.unDependentOption;
                this.isNumeric = this.fieldConfig.isNumeric ? this.fieldConfig.isNumeric : false;
            }

            if (this.formFieldConfig) {
                this.isHiglineField = this.formFieldConfig.isHiglineField;
                this.itemSubSection = this.formFieldConfig.itemSubSection;
            }
            this.hideTitle = (this.formFieldConfig && this.formFieldConfig.hideTitle) ? this.formFieldConfig.hideTitle : false;
            this.name = (this.formFieldConfig && this.formFieldConfig.displayText) ? this.formFieldConfig.displayText : this.formFieldInfo.name;
            this.tooltip = this.formFieldConfig && this.formFieldConfig.tooltip ? this.formFieldConfig.tooltip : "";
            
            this.formCode=localStorage.getItem('FORM_CODE');
            this.taxCode=localStorage.getItem('TAXCODE');            
            this.bindingData();
        } catch (error) {
            this.formFieldConfig = JSON.parse('{ "pattern": "" }');
            this.fieldConfig = JSON.parse('{ "keydownPattern": "" }');
        }
    }

    bindingData(){
        this.customfieldOptionList = this.formFieldInfo.customfieldOptionList;
        if (this.modalTitle == TITLE.ADD_DATA)//This case is: Click icon(+) to open popup
        {
            let arrayDefaultValue = this.formFieldInfo.defaultValue.split("|");
            this.radioValue = arrayDefaultValue.length > 0 ? arrayDefaultValue[0] : "";
        }
        else if (this.modalTitle == TITLE.UPDATE_DATA) { //This case is: Click icon(edit) to open popup
            if (this.formData) {
                let objectData = this.formData;
                const keys = Object.keys(objectData);
                keys.forEach((key) => {
                    if (key == this.formFieldInfo.fieldCode) {
                        let value = objectData[key];
                        let radioTempInput = '';
                        let radioTempVal = '';
                        if (value.includes(':')) {
                            let splittedData = value.split(':');
                            radioTempInput = splittedData[1].trim();
                            radioTempVal = splittedData[0].trim();
                            objectData[key]= radioTempVal;  
                            //handle input of radio
                            let subInput = this.formFieldInfo.customfieldOptionList.find(x => { return x.optionValue == radioTempVal });
                            this.formGroup.controls[`${key}-${subInput.optionCode}_INPUT`].setValue(radioTempInput);
                        }
                        if(value.includes('|'))
                            value = value.split('|')[0]
                        //bind data to radio Value
                        let dataRad = this.formFieldInfo.customfieldOptionList.find(x => { return x.optionValue == value || x.optionCode == value })
                        this.radioValue = dataRad.optionCode;
                    }
                });
            }
        }
        else {
            let storageVal = localStorage.getItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+this.fieldCode);
            if(storageVal && storageVal.includes('|')){
                storageVal = storageVal.split('|')[0]
                localStorage.setItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+this.fieldCode, storageVal);
            }
                
            if (storageVal) {
                this.radioValue = storageVal;
            } else if (this.formData && this.formData[this.fieldCode]) {
                this.radioValue = this.formData[this.fieldCode];
            } else if (this.formFieldInfo.defaultValue) {
                let arrayDefaultValue = this.formFieldInfo.defaultValue.split("|");
                this.radioValue = arrayDefaultValue.length > 0 ? arrayDefaultValue[0] : "";
            }
            for (let i = 0; i < this.customfieldOptionList.length; i++) {
                let item = this.customfieldOptionList[i];
                let fieldOptionConfig = item.fieldOptionConfig ? JSON.parse(item.fieldOptionConfig) : null;
                this.dependentFieldsOption = [{ fieldCode: "", fieldsOptionList: [] }];
                let hasSubSession = false;
                let optionClass = "col-sm-3";
                let allowInput=item.allowInput;
                if(allowInput){
                    this.inputSubValue = localStorage.getItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ item.fieldCode+'-'+item.optionCode+'_INPUT');
                    if(localStorage.getItem('TEMP_'+ this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ item.fieldCode)){
                        this.inputSubValue = localStorage.getItem('TEMP_'+ this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ item.fieldCode);
                    }
                    this.inputFieldCode=item.fieldCode;
                    this.inputOptionCode=item.optionCode;
                }
                if (fieldOptionConfig) {
                    hasSubSession = fieldOptionConfig.hasSubSession ? fieldOptionConfig.hasSubSession : false;
                    this.dependentFieldsOption = fieldOptionConfig.dependentFieldsOption || fieldOptionConfig.dependentFieldsOption;
                    this.calValue = fieldOptionConfig.calValue;
                }
    
                this.customfieldOptionList[i].hasSubSession = hasSubSession;
                this.customfieldOptionList[i].optionClass = optionClass;
            }
        }
    }
    ngAfterViewInit() {
        this.flag = false;
        if(this.inputFieldCode !=undefined && this.inputOptionCode!=undefined){
            (<HTMLInputElement>document.getElementById(`${this.inputFieldCode}-${this.inputOptionCode}_INPUT`)).value =  this.inputSubValue;
        }
        if (this.formData) {
            this.setSubItemsValue();
        }

        if(this.elementRef.nativeElement.id.includes('TABLE')){
            this.flag = true;
        }
    }

    displayDivOptionOfRadioButton() {
        this.isDisplayDivOptionOfRadioButton = true;
        let fieldCodeOption, fieldsOptionList
        for (let i = 0; i < this.dependentFieldsOption.length; i++) {
            let item = this.dependentFieldsOption[i];
            fieldCodeOption = item.fieldCode;
            fieldsOptionList = item.fieldsOptionList;
        }
    }

    changeRadioValue() {
        this.itemListByValue = this.itemList;
        let selectedOption = this.customfieldOptionList.filter(x => x.optionCode == this.radioValue)[0];
        let config = selectedOption && selectedOption.fieldOptionConfig ? JSON.parse(selectedOption.fieldOptionConfig) : null;
        let hasSubSession = config ? config.hasSubSession : false;
        if (hasSubSession && this.itemList && this.itemList.length > 0) {
            this.itemListByValue = this.itemList.filter(x => JSON.parse(x.formFieldConfig).itemSubSection == this.fieldCode + '-' + this.radioValue);
            this.isHiddenSubItem = false;
        } else {
            this.isHiddenSubItem = true;
        }
        let fieldCodeOption, fieldsOptionList;
        if (this.dependentFieldsOption) {
            for (let i = 0; i < this.dependentFieldsOption.length; i++) {
                let item = this.dependentFieldsOption[i];
                fieldCodeOption = item.fieldCode;
                fieldsOptionList = item.fieldsOptionList;
            }
        }

        // NumberField
        if (this.numberFormFieldInfo) {
            let formula = "";
            let json = JSON.parse('{ "itemSubSection": ""}');
            try {
                json = JSON.parse(this.numberFormFieldInfo.formFieldConfig);
            } catch (err) {
                json = JSON.parse('{ "itemSubSection": ""}');
            }

            if (json && json.condition) {
                formula = json.condition;
                let lstField = formula.split(/\(([^()]*)\)+/g);
                let uniqueNames = [];

                lstField.forEach(el => {
                    if (uniqueNames.indexOf(el) == -1) uniqueNames.push(el);
                });

                uniqueNames.forEach(item => {
                    if (item.includes(FieldTypeCode.RADIO_BUTTON)) {
                        let valueRadio = (<HTMLInputElement>document.getElementById(item)).value;
                        if (valueRadio) {
                            (<HTMLInputElement>document.getElementById(this.formFieldInfo.fieldCode)).value = "";
                        }
                        else {
                            let config = this.numberFormFieldInfo.formFieldConfig ? JSON.parse(this.numberFormFieldInfo.formFieldConfig) : null;
                            if (config) {
                                this.CalculatorForNumberField(formula, config.isMathRound);
                            }
                        }
                    }
                });
            }
        }

        if(this.radioValue && this.radioValue.includes('|'))
            this.radioValue = this.radioValue.split('|')[0]

        localStorage.setItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+this.fieldCode, this.radioValue);
    }

    getCol(item: any) {
        if (item.fieldTypeCode == FieldTypeCode.TITLE) {
            return ' col-md-12';
        }
        else {
            return 'col-md-' + (item.width * 12 / 3) + ' col-xs-12 ';
        }
    }

    focusInput(option) {
        this.radioValue = option.optionCode;
    }

    addClass(config) {
        if (config && JSON.parse(config)) {
            return JSON.parse(config).optionClass ? JSON.parse(config).optionClass : "col-sm-3";
        }

        return "";
    }

    keydownValidateAllowInput(option) {
        let message = "";
        let validate = true;
        let number: any;
        let keydownPattern = this.fieldConfig.keydownPattern;
        let radioInput = (<HTMLInputElement>document.getElementById(`${option.fieldCode}-${option.optionCode}_INPUT`)).value;

        if (this.isNumeric) {
            number = parseFloat(stringFormatToFloat(radioInput).toString());
            if (isNaN(number) || number) {
                validate = false;
                message = " sai định dạng format";
            } else {
                let valNumber = radioInput.replace(/[\*\^\,\'\!]/g, '');
                if (radioInput != "") {
                    number = stringFormatToFloat(radioInput);
                    if (radioInput.split('.')[1]) {
                        let valueNumeric = floatToStringFormat(number);
                        (<HTMLInputElement>document.getElementById(`${option.fieldCode}-${option.optionCode}_INPUT`)).value = valueNumeric;
                    }
                    else {
                        let valueNumeric = floatToStringFormat(number);
                        if (radioInput.includes('.')) {
                        } else {
                            (<HTMLInputElement>document.getElementById(`${option.fieldCode}-${option.optionCode}_INPUT`)).value = valueNumeric;
                        }
                    }
                }
            }
        }

        if (keydownPattern) {
            let pattern = new RegExp(keydownPattern);
            if (pattern) {
                if (!pattern.test(this.radioInput) && this.radioInput) {
                    validate = false;
                    message = " sai định dạng format";
                    this.radioInput = this.radioInput.substring(0, this.radioInput.length - 1);
                }
            }

            if (!validate) {
                this.nzModalNotification.error("Cảnh báo", "Chuỗi " + message);
                return true;
            }
        }
        localStorage.setItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ `${option.fieldCode}-${option.optionCode}_INPUT`, radioInput);
    }

    CalculatorForNumberField(formula, isMathRound) {
        // $(bodyElement).find('#' + obj.fieldCode).attr('style', 'width: 100%;border: solid 1px #a1bad3 !important; width: 100%;');
        let sum = 0;
        if (formula) {
            sum = isMathRound ? Math.round(eval(formula)) : eval(formula);
        }
        let value = "";

        if (isNaN(sum) || isFinite(sum)) {
            value = "";
        }
        else {
            value = floatToStringFormat(stringFormatToFloat(sum));
        }
        (<HTMLInputElement>document.getElementById(this.numberFormFieldInfo.fieldCode)).value = value;
    }

    selectOutput(item) {
        this.selectChildData = [];
        if (item) {
            let childField;
            if (this.listFormFieldInfo) {
                childField = this.listFormFieldInfo.find(x => {
                    if (x.fieldConfig) {
                        let config = (x.fieldConfig && x.fieldConfig.indexOf('input') > -1) ? JSON.parse(x.fieldConfig) : null;
                        let parentId = config && config.apiConfig && config.apiConfig.request ? config.apiConfig.request.input : '';
                        if (item.fieldInfo.fieldCode == parentId)
                            return true;
                    }

                    return false;
                });
            }

            if (childField) {
                this.selectChildData = { fieldCode: childField.fieldCode, data: [] };
                let fieldConfig = childField.fieldConfig ? JSON.parse(childField.fieldConfig) : null;
                if (fieldConfig && fieldConfig.apiConfig.url) {
                    if (item.input && item.input.dataValueField) {
                        this.formService.callApiUrl(fieldConfig.apiConfig.url, { input: item.input.dataValueField }).subscribe(
                            res => {
                                if (res.result && res.result.length > 0) {
                                    this.selectChildData = { fieldCode: childField.fieldCode, data: res.result };
                                }
                            },
                            error => {
                                console.log(error);
                            }
                        )
                    }
                }
            }
        }
    }

    tableOutput(e) {
        console.log(e);
    }

    getSubItemsList(component: FormFieldInfo) {
        let fieldCode = component.fieldCode;
        let itemList = [];
        if (this.listFormFieldInfo) {
            itemList = this.listFormFieldInfo.filter(x => {
                if (x.formFieldConfig) {
                    let config = JSON.parse(x.formFieldConfig)
                    if (config && config.itemSubSection) {
                        for (const opt of component.customfieldOptionList) {
                            if (config.itemSubSection == opt.fieldCode + '-' + opt.optionCode) {
                                return true;
                            }
                        }
                    }
                }

                return false;
            });
        } else {
            itemList = [];
        }

        return itemList;
    }

    getMultipleChoiceCustomfieldList(component: FormFieldInfo) {
        let fieldCode = component.fieldCode;
        let filteredCustomfieldOptionList = [];

        let filteredFormFieldInfo = this.listFormFieldInfo.filter(x => {
            let fieldConfig = (x.fieldConfig && x.fieldConfig.indexOf('dependentField') > -1) ? JSON.parse(x.fieldConfig) : null;

            if (fieldConfig && fieldConfig.dependentField) {
                return fieldConfig.dependentField.indexOf(component.fieldCode) > -1;
            }

            return false;
        })[0];

        if (filteredFormFieldInfo) {
            filteredCustomfieldOptionList = filteredFormFieldInfo.customfieldOptionList.filter(x => {
                let fieldOptionConfig = x.fieldOptionConfig ? JSON.parse(x.fieldOptionConfig) : null;
                if (fieldOptionConfig) {
                    let dependentFieldsOption = fieldOptionConfig.dependentFieldsOption.filter(y => y.fieldCode == fieldCode)[0];
                    return dependentFieldsOption.fieldCode == fieldCode;
                }
                return false;
            });
        }

        return filteredCustomfieldOptionList;
    }

    setSubItemsValue() {
        let itemList = [];
        this.formFieldInfo.customfieldOptionList.forEach(option => {
            if (this.formData[option.fieldCode] == option.optionCode) {
                this.listFormFieldInfo.forEach(x => {
                    //console.log(x)
                    if (x.formFieldConfig) {
                        let config = JSON.parse(x.formFieldConfig)
                        if (config && config.itemSubSection) {
                            if (config.itemSubSection == option.fieldCode + '-' + option.optionCode) {
                                itemList.push(x);
                            }
                        }
                    }
                });
            }
        })

        itemList.forEach(item => { this.formGroup.controls[item.fieldCode].setValue(this.formData[item.fieldCode]); });
    }

    isShow(item, option) {
        let config = JSON.parse(item.formFieldConfig);
        if (config && config.itemSubSection) {
            if (config.itemSubSection == `${option.fieldCode}-${option.optionCode}` && option.checked) {
                return true;
            }
        }

        return false;
    }

    numberAddEvent(value) {
        this.numberFormFieldInfo = value;
    }
}